var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconLoad = function SvgIconLoad(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    style: {
      fill: "currentColor"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3986 0.661117V2.95708C1.3986 3.31574 1.68935 3.60648 2.048 3.60648H4.34397C4.70262 3.60648 4.99337 3.31574 4.99337 2.95708C4.99337 2.59843 4.70262 2.30769 4.34397 2.30769L3.81021 2.30702C5.55612 1.26269 7.85174 1.49251 9.35571 2.99648C11.1309 4.77172 11.1309 7.64995 9.35571 9.42519C7.58047 11.2004 4.70224 11.2004 2.927 9.42519C1.84652 8.34471 1.39423 6.8192 1.67804 5.34612C1.74589 4.99395 1.5154 4.65345 1.16322 4.5856C0.811045 4.51775 0.470546 4.74824 0.402695 5.10041C0.0381927 6.99235 0.620109 8.95508 2.00861 10.3436C4.29106 12.626 7.99164 12.626 10.2741 10.3436C12.5565 8.06113 12.5565 4.36054 10.2741 2.07809C8.20918 0.0131791 4.98358 -0.183627 2.69742 1.48767L2.6974 0.661117C2.6974 0.302464 2.40665 0.0117188 2.048 0.0117188C1.68935 0.0117188 1.3986 0.302464 1.3986 0.661117Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLoad, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-load.486554ed.svg";
export { ForwardRef as ReactComponent };